import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Spinner from '~/components/Spinner';

import { loadStatistics } from './actions';
import { selectError, selectLoading, selectStatistics } from './selectors';

const mapStateToProps = createStructuredSelector({
  loading: selectLoading,
  error: selectError,
  statistics: selectStatistics,
});

const mapDispatchToProps = dispatch => ({
  loadStatistics: (id, type) => dispatch(loadStatistics(id, type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class Statistics extends Component {
    static propTypes = {
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      render: PropTypes.func.isRequired,
      statistics: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    };

    static defaultProps = {
      statistics: undefined,
    };

    componentDidMount() {
      const { id, type, statistics } = this.props;
      if (!statistics) {
        this.props.loadStatistics(id, type);
      }
    }

    render() {
      const { statistics, render } = this.props;
      return (
        <Spinner {...this.props}>{statistics && render(statistics)}</Spinner>
      );
    }
  },
);
